import { Component } from '@angular/core';

@Component({
    selector: 'app-ecosystem',
    templateUrl: './ecosystem.component.html',
    styleUrls: ['./ecosystem.component.scss'],
    standalone: false
})
export class EcosystemComponent {}
